import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { CP_CheckPermission } from "../Class/Class_Permission"
import { Class_ETC_SessionTimeOut } from "../Class/Class_Etc";

function M_service_info() {

  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);

  const [startDay, setStartDay] = useState("");
  const [startDayst, setStartDayst] = useState("");
  const [serviceDate, setServiceDate] = useState("");
  const [serviceDate_day, setServiceDate_day] = useState("");
  const [serviceDate_dayClass, setServiceDate_dayClass] = useState("");
  const [maxStaff, setMaxStaff] = useState(0);
  const [activeStaff, setActiveStaff] = useState(0);

  
  useEffect(() => {
    let ckpermission = CP_CheckPermission("master" , ["service_info_view"] , false , true)
    if (ckpermission === true) {
      GetConfig();
      if (isLoadedConfigData === true) {
        BindDetail(function() {
          setIsLoadProgress(false);
        });
      }
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);


  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }
  

  async function BindDetail(_callback){
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ServiceInfo_GetDetail",
        requestOptions
      );

      const json = await response.json();

      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setStartDay(json.service_start_day);
          setStartDayst((json.service_start_day === 1 ? "st" :
                         json.service_start_day === 2 ? "nd" :
                         json.service_start_day === 3 ? "rd" : "th"
                        ));
          setServiceDate(json.service_date);
          setServiceDate_day(json.service_day);
          setServiceDate_dayClass(json.service_day_class);
          setMaxStaff(json.max_staff);
          setActiveStaff(json.active_staff);
        }
        if (_callback != null) {
            _callback();
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else{
        if (_callback != null) {
            _callback();
        }
      }
    } catch {
      if (_callback != null) {
          _callback();
      }
    }
  }


  return (
    <>
      <Helmet>
        <title>Company Info</title>
      </Helmet>
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      <div className="content-wrapper">
        <div className="content-header">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="container-fluid">
                <h1 className="display-5 text-center">
                  {" "}
                  <i className="fas fa-info-circle" /> Service Info{" "}
                </h1>
              </div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <div className="card  shadow">
                  <div className="card-body">
                    <div className="form-horizontal">
                      <div className="form-group row">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Start Day
                        </label>
                        <div className="col-sm-10">
                          <div className="mt-1">
                            {" "}
                            {startDay !== "" &&
                              <>
                                {startDay} <sup>{startDayst}</sup>
                              </> 
                            }
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Service Date
                        </label>
                        <div className="col-sm-10">
                          <div className="mt-1">
                            {serviceDate}
                            {serviceDate_day !== "" &&
                              <>
                                <span
                                  className={serviceDate_dayClass}
                                  data-toggle="tooltip"
                                  title="SLA"
                                >
                                  {" "}
                                  {serviceDate_day}
                                </span>
                              </> 
                            }
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Max Staff
                        </label>
                        <div className="col-sm-10">
                          <div className="mt-1">
                            {" "}
                            {maxStaff} <small>staffs</small>{" "}
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="text-sm col-sm-2 col-form-label text-right">
                          Active Staff
                        </label>
                        <div className="col-sm-10">
                          <div className="mt-1">
                            {" "}
                            {activeStaff} <small>staffs</small>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


      </div>

    </>
  );
}

export default M_service_info;
